export enum BannerType {
	Neutral = 'neutral',
	Info = 'info',
	Success = 'success',
	Warning = 'warning',
	Danger = 'danger'
}
